<script lang="ts">
  export let tooltipText = '';
  export let position:
    | 'bottom'
    | 'left'
    | 'top'
    | 'bottom-left'
    | 'bottom-right' = 'bottom';
  export let id = 'tooltip-box';
  export let showTooltip = true;
  export let focusWithin = false;
  export let tooltipTextTestId: string | null = null;

  const tooltipSlotId: string = 'tooltip-slot';
  const tabindex = focusWithin ? -1 : 0;
</script>

{#if showTooltip}
  <span
    class="custom-tooltip"
    class:focus-within={focusWithin}
    data-testid={id}
    {tabindex}
    data-tooltip-position={position}
  >
    <div data-testid={tooltipSlotId}>
      <slot />
    </div>
    <div class="tooltip-text" role="tooltip" data-testid={tooltipTextTestId}>
      {@html tooltipText}
    </div>
  </span>
{:else}
  <div data-testid={tooltipSlotId}>
    <slot />
  </div>
{/if}

<style lang="postcss">
  .custom-tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip-text,
  .tooltip-text:after {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: 0.2s ease-out;
  }

  .tooltip-text {
    transform: translate(-50%, 5px);
    position: absolute;
    left: 50%;
    padding: 0.5rem;
    width: max-content;
    max-width: 250px;
    -webkit-border-radius: 0.25rem;
    -moz-border-radius: 0.25rem;
    border-radius: 0.25rem;
    background-color: #262626;
    color: #fff;
    white-space: break-spaces;
    font-size: 0.875rem;
    line-height: 1.375rem;
    z-index: 1050;
  }

  .custom-tooltip[data-tooltip-position='bottom'] .tooltip-text {
    top: calc(100% + 0.3125rem);
  }

  .custom-tooltip[data-tooltip-position='left'] .tooltip-text {
    bottom: calc(100% + 0.3125rem);
    left: calc(-50% - 5rem);
  }

  .custom-tooltip[data-tooltip-position='top'] .tooltip-text {
    bottom: calc(100% + 0.3125rem);
  }

  .custom-tooltip[data-tooltip-position='bottom-left'] .tooltip-text {
    top: calc(100% + 0.3125rem);
    left: calc(-50%);
  }

  .custom-tooltip[data-tooltip-position='bottom-right'] .tooltip-text {
    top: calc(100% + 0.3125rem);
    left: auto;
    right: 0;
    transform: translate(0, 5px);
  }

  .tooltip-text:after {
    position: absolute;
    left: 50%;
    width: 0;

    border-right: 0.3125rem solid transparent;
    border-left: 0.3125rem solid transparent;
    content: ' ';
    font-size: 0;
    line-height: 0;
  }

  .custom-tooltip[data-tooltip-position='bottom'] .tooltip-text:after {
    border-bottom: 0.3125rem solid #262626;
    bottom: 100%;
  }

  .custom-tooltip[data-tooltip-position='top'] .tooltip-text:after {
    border-top: 0.3125rem solid #262626;
    top: 100%;
  }

  .custom-tooltip[data-tooltip-position='left'] .tooltip-text:after {
    top: 100%;
    border-top: 0.3125rem solid #262626;
    left: 89%;
  }

  .custom-tooltip[data-tooltip-position='bottom-right'] .tooltip-text:after {
    border-bottom: 0.3125rem solid #262626;
    bottom: 100%;
    left: auto;
    right: 0.1875rem;
  }

  .custom-tooltip[data-tooltip-position='bottom-left'] .tooltip-text:after {
    border-bottom: 0.3125rem solid #262626;
    bottom: 100%;
    left: 0.1875rem;
  }

  .custom-tooltip.focus-within:focus-within .tooltip-text,
  .custom-tooltip.focus-within:focus-within .tooltip-text:after,
  .custom-tooltip:hover .tooltip-text,
  .custom-tooltip:hover .tooltip-text:after,
  .custom-tooltip:focus .tooltip-text,
  .custom-tooltip:focus .tooltip-text:after {
    visibility: visible;
    opacity: 1;
  }

  .custom-tooltip.focus-within:focus-within .tooltip-text,
  .custom-tooltip:hover .tooltip-text,
  .custom-tooltip:focus .tooltip-text {
    pointer-events: auto;
  }

  .custom-tooltip:not([data-tooltip-position='bottom-right']):hover
    .tooltip-text,
  .custom-tooltip:not([data-tooltip-position='bottom-right']):focus
    .tooltip-text,
  .custom-tooltip.focus-within:not(
      [data-tooltip-position='bottom-right']
    ):focus-within
    .tooltip-text {
    transform: translate(-50%, 0);
  }

  .custom-tooltip[data-tooltip-position='bottom-right']:hover .tooltip-text,
  .custom-tooltip[data-tooltip-position='bottom-right']:focus .tooltip-text,
  .custom-tooltip.focus-within[data-tooltip-position='bottom-right']:focus-within
    .tooltip-text {
    transform: translate(0, 0);
  }
</style>
